(() => {
  let cleanup = null;

  const initialize = () => {
    cleanup?.();

    const header = document.querySelector('.cw-redesign-header');
    if (!header) {
      cleanup = null;
      return;
    }

    const controller = new AbortController();
    let scrolled = window.scrollY >= 12;
    let frame = 0;

    const applyState = () => {
      frame = 0;
      const scrollPosition = Math.max(0, window.scrollY || 0);

      if (scrolled) {
        if (scrollPosition <= 2) scrolled = false;
      } else if (scrollPosition >= 12) {
        scrolled = true;
      }

      header.classList.toggle('is-scrolled', scrolled);
    };

    const update = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(applyState);
    };

    applyState();
    window.addEventListener('scroll', update, { passive: true, signal: controller.signal });
    window.addEventListener('pageshow', update, { signal: controller.signal });

    cleanup = () => {
      controller.abort();
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
    };
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.cw-redesign-header')) initialize();
  });
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector('.cw-redesign-header')) cleanup?.();
  });
})();

// Google-Maps-Karten der Standortkarten erst nach Einwilligung (Präferenzen) oder Klick laden.
(() => {
  const consentAllowsMaps = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return false;
    const consent = privacy.currentVisitorConsent() || {};
    return consent.preferences === 'yes';
  };

  const loadMap = (container) => {
    if (container.classList.contains('is-loaded')) return;
    const frame = container.querySelector('iframe[data-src]');
    if (!frame) return;
    frame.setAttribute('src', frame.getAttribute('data-src'));
    frame.removeAttribute('hidden');
    container.classList.add('is-loaded');
  };

  const loadAll = (root = document) => root.querySelectorAll('[data-cw-map]').forEach(loadMap);

  const initialize = (root = document) => {
    if (consentAllowsMaps()) loadAll(root);
  };

  // Die Consent-API kann nach dem Seitenaufbau nachladen: kurz nachprüfen (max. 10 s).
  const waitForConsentApi = () => {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      const ready = window.Shopify && window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.currentVisitorConsent === 'function';
      if (ready) initialize();
      if (ready || attempts >= 20 || !document.querySelector('[data-cw-map]:not(.is-loaded)')) {
        window.clearInterval(timer);
      }
    }, 500);
  };

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element && event.target.closest('[data-cw-map-load]');
    if (!button) return;
    // Ein Klick erlaubt Google Maps für alle Karten dieser Seite.
    loadAll();
  });

  document.addEventListener('visitorConsentCollected', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  const start = () => {
    initialize();
    if (document.querySelector('[data-cw-map]:not(.is-loaded)')) waitForConsentApi();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
